import { memo } from 'react';

import { SourcesSelect } from '~/components/Selects/SourcesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePrivateSourcesList } from '~/swr-hooks/filters/usePrivateSourcesList';

type PrivateSourcesSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateSourcesSelect = memo(({ boardId, libraryId, ...props }: PrivateSourcesSelectProps) => {
  const { data = [], isLoading } = usePrivateSourcesList({
    boardId,
    libraryId,
  });

  return <SourcesSelect isLoading={isLoading} sources={data} {...props} />;
});

PrivateSourcesSelect.displayName = 'PrivateSourcesSelect';
